<template>
    <transition name="fade">
        <div class="notify-modal text_11" v-if="notifySize" v-bsl="notifySize">
            <div class="notify-modal__content">
                <div class="row row--fullwidth">
                    <div class="col lg-5 col--centered sm-12">
                        <div class="notify-modal__form" v-click-outside="close">
                            <div class="notify-modal__header">
                                <div class="notify-modal__caption">{{ $t("notify") }}</div>
                                <div class="notify-modal__close like-link" @click="close()">
                                    {{ $t("close") }}
                                </div>
                            </div>

                            <div class="notify-modal__body" v-if="!isSended">
                                <div class="color-text_2">
                                    {{ $t("notify_size1") }} {{ notifySize }} {{ $t("notify_size2") }}
                                </div>
                                <div class="form-group" v-for="(input, name) in notifyForm" :key="name">
                                    <Input
                                        v-if="name !== 'phone'"
                                        :key="'input-' + input.name"
                                        :name="name"
                                        :label="input.label"
                                        :required="input.required"
                                        :cleaveOptions="input.cleaveOptions"
                                        v-model="input.value"
                                        :isValid="input.required ? input.isValid : true"
                                        :validationMessage="input.required ? input.validationMessage : ''" />
                                    <Input
                                        v-else
                                        :key="'input-' + name"
                                        :name="name"
                                        :label="input.label"
                                        :required="input.required"
                                        :cleaveOptions="input.cleaveOptions"
                                        v-model="input.value"
                                        :isValid="input.required ? input.isValid : true"
                                        :validationMessage="input.required ? input.validationMessage : ''"
                                        v-mask="'# (###) ###-##-########'" />
                                </div>
                                <div class="form-group">
                                    <button
                                        @click="sendNotify"
                                        class="button button--wide text_11"
                                        :disabled="isButtonClicked">
                                        {{ $t("notify_ok") }}
                                    </button>
                                </div>
                                <div class="notify-modal__footer text_9">
                                    <span class="color-text_3">{{ $t("terms_notify") }}</span>
                                    <nuxt-link to="/dokumenty/oferta/" target="_blank">{{
                                        $t("public_offer_terms")
                                    }}</nuxt-link>
                                    {{ $t("and") }}
                                    <nuxt-link
                                        to="/dokumenty/soglashenie-ob-obrabotke-persnonalnyh-dannyh/"
                                        target="_blank">
                                        {{ $t("pp") }}
                                    </nuxt-link>
                                </div>
                            </div>
                            <div class="notify-modal__body color-text_2" v-else>{{ $t("notify_success") }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import Input from "@/components/form/Input";
import { mapGetters, mapActions } from "vuex";
import { mask } from "vue-the-mask";
export default {
    name: "NotifyModal",
    props: ["notify"],
    directives: { mask },
    components: { Input },
    data() {
        return {
            notifyForm: {
                name: {
                    label: this.$i18n.t("name"),
                    required: true,
                    isValid: true,
                    validationMessage: "",
                    value: "",
                },
                email: {
                    label: "email",
                    required: true,
                    isValid: true,
                    validationMessage: "",
                    value: "",
                },
                phone: {
                    label: this.$i18n.t("phone"),
                    isValid: true,
                    required: true,
                    validationMessage: "",
                    value:
                        this.$auth.loggedIn && this.$auth.user.phone
                            ? this.$auth.user.phone
                            : this.currentCountryPhoneCode,
                },
            },
            isButtonClicked: false,
            isSended: false,
        };
    },
    watch: {
        currentCountry() {
            this.notifyForm.phone.value =
                this.$auth.loggedIn && this.$auth.user.phone ? this.$auth.user.phone : this.currentCountryPhoneCode;
        },
    },
    computed: {
        ...mapGetters({
            currentCountry: "globalvars/getCurrentCountry",
            currentCountryPhoneCode: "globalvars/getCurrentCountryPhoneCode",
            notifyId: "notify/getId",
            notifySize: "notify/getSize",
        }),
    },
    methods: {
        ...mapActions({
            setNotify: "notify/setNotify",
        }),
        close() {
            this.isSended = false;
            this.setNotify({ size: null });
        },
        sendNotify() {
            let is_valid = true;
            for (const key in this.notifyForm) {
                if (this.notifyForm[key].required && !this.notifyForm[key].value) {
                    this.notifyForm[key].isValid = false;
                    this.notifyForm[key].validationMessage = "Заполните поле";
                    is_valid = false;
                } else {
                    this.notifyForm[key].isValid = true;
                }
            }

            if (!this.$grom.validateEmail(this.notifyForm.email.value)) {
                this.notifyForm.email.isValid = false;
                this.notifyForm.email.validationMessage = "Не правильно заполнено поле";
                is_valid = false;
            } else {
                this.notifyForm.email.isValid = true;
            }

            if (this.notifyForm.phone.value.length < 16) {
                this.notifyForm.phone.isValid = false;
                this.notifyForm.phone.validationMessage = "Не правильно заполнено поле";
                is_valid = false;
            } else {
                this.notifyForm.phone.isValid = true;
            }

            if (!is_valid) return;

            this.isButtonClicked = true;
            const roistat_visit =
                document.cookie
                    .split(";")
                    .filter((item) => {
                        return item.indexOf("roistat_visit=") + 1;
                    })?.[0]
                    ?.split("=")[1] || "нет значения";
            this.$axios
                .post("/api/notify", {
                    sku_id: this.notifyId,
                    name: this.notifyForm.name.value,
                    email: this.notifyForm.email.value,
                    phone: this.notifyForm.phone.value,
                    last_name: this.$i18n.t("family_error"),
                    first_name: this.$i18n.t("name_error"),
                    roistat_visit,
                })
                .then(() => {
                    this.isSended = true;
                    this.$forceUpdate();
                    // ga("send", "event", "notification", "send");
                })
                .catch((error) => {
                    if (error.response.status == 406) {
                        let notValidFields = error.response.data.data;
                        console.log(`error.response =>`, error.response);
                        this.isButtonClicked = false;
                        for (const key in notValidFields) {
                            if (notValidFields.hasOwnProperty(key)) {
                                const element = notValidFields[key];
                                this.notifyForm[key].isValid = false;
                                this.notifyForm[key].validationMessage = element[0];
                            }
                        }
                        document.querySelector(`[name="${Object.keys(notValidFields)[0]}"]`).focus();
                    }
                });
        },
    },
    mounted() {
        this.notifyForm.phone.value =
            this.$auth.loggedIn && this.$auth.user.phone ? this.$auth.user.phone : this.currentCountryPhoneCode;
    },
};
</script>
<style lang="less" scoped>
.notify-modal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 6;
    background: rgba(242, 241, 233, 0.7);
    display: flex;
    align-items: center;
    &__content {
        width: 100%;
    }
    &__header {
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 32px;
        border-bottom: 1px solid @border2;
    }
    &__close {
        border-bottom: 1px solid;
    }
    &__body {
        padding: 40px 32px;
        .form-group {
            margin-top: 40px;
        }
        .form-group__label {
            margin-top: 10px;
        }
    }
    &__form {
        background: @bg;
    }
    &__footer {
        margin-top: 16px;
    }
}
</style>
